export const relationships = [
  { value: '1', label: 'constants.relationships.spouse' },
  { value: '2', label: 'constants.relationships.significantOther' },
  { value: '3', label: 'constants.relationships.adultChild' },
  { value: '4', label: 'constants.relationships.sibling' },
  { value: '5', label: 'constants.relationships.otherFamilyMember' },
  { value: '6', label: 'constants.relationships.friend' },
  { value: '7', label: 'constants.relationships.other' },
]
